<color-sketch [presetColors] ="colors" [color]="color" (onChangeComplete)="handleChangeComplete($event)" (onChange)="handleColorPick($event)"></color-sketch>
